import templateUrl from './header.html';
import { HeaderController } from '../controllers/headerController';

export function HeaderDirective($window){
    'ngInject';
    return {
        replace: true,
        scope: {},
        controllerAs: 'vm',
        bindToController: true,
        templateUrl,
        restrict: 'E',
        controller: HeaderController,
        link: function(scope, element, attrs, ctrl) {
            const WINDOW = angular.element($window);
            WINDOW.on('scroll', function() {
                let isScrolled = $window.pageYOffset > 100;
                ctrl.isScrolled = isScrolled;
                element.toggleClass('scrolled', isScrolled);
                scope.$digest();
            });
        }
    };
}
